import { axiosInstance } from "@/helper/axios-instance";
import type { StockPriceRegister, DataAwareResponse } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useStockPriceRegisterUpdate(id: string) {
  return useMutationWithValidation({
    mutationFn: async (data: Partial<StockPriceRegister>) => {
      const response = await axiosInstance({
        method: "PUT",
        url:  `StockPriceRegister/Update?id=${id}`,
        data: data,
      });

      return response?.data as DataAwareResponse<StockPriceRegister>;
    },
    retry: 2,
    customMessage: {
      success: "Stock price register updated successfully",
    },
  });
}
